export enum DateSuggestedBy {
  Candidate = 'candidate',
  Employer = 'employer',
}

export const DATE_SUGGESTED_BY_I18N: Record<string, string> = {
  [DateSuggestedBy.Candidate]: 'Kandidat',
  [DateSuggestedBy.Employer]: 'Arbeitgeber',
};
